import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useSelector } from 'react-redux';
import { baseUrl } from "../../shared/baseUrl";
import { Link, useNavigate} from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import ReactPaginate from "react-paginate";
import TableHandler from '../../components/admin/TableHandler';
import moment from 'moment';

const AllSubscriptions = () => {
  const navigate = useNavigate()

  const [toggleNav, setToggleNav] = useState(false)
  
  const [data, setData] = useState([])

  const [loading, setLoading] = useState(false)

   // --- Pagination --- //
   const [pageNumber, setPageNumber] = useState(0)
   const itemsPerPage = 10
   const pagesVisited = pageNumber * itemsPerPage
   const pageCount = Math.ceil(data?.length / itemsPerPage)
   const changePage = ({ selected }) => setPageNumber(selected)
   const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
   // --- Pagination --- //

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    document.title = "Island Luxury - Subcription Plans"
		if(!userInfo) {
			navigate("/")
		}
    else {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo?.token}`
        }
      }
      const getPlans = async () => {
        try {
          setLoading(true)
          const res = await axios.get(baseUrl + "/api/v1/subscriptions", config)
          setData(res.data.subscriptions)
          setLoading(false)
        }
        catch (err) {
          console.log(err.response && err.response.data.message ? err.response.data.message : err.message)
          setLoading(false)
        }
      }
      getPlans()
    }
	}, [userInfo, navigate])

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="my-listing">
        <section className="page-title">
          <h3><Link to="/dashboard">Dashboard</Link> | Subcription Plans</h3>
        </section>
        <section className="my-listing_cont">
          <div className="table-search_area">
            <div>
              {/* <form>
                <input type="text" placeholder="Search Email or Username" value={searchXY} onChange={(e) => setSearchXY(e.target.value)} />
              </form> */}
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Depositor's Name</th>
                <th>Username</th>
                <th>Plan</th>
                <th>Payment Date</th>
                <th>Bank</th>
                <th>Channel</th>
              </tr>
            </thead>
            <tbody>
              {!loading && displayData.map((item, index) =>
                <tr key={index}>
                  <td>{item.depositorsName}</td>
                  <td>{item.user.username}</td>
                  <td>{item.subscriptionPlan}</td>
                  <td>{moment(item.paymentDate).format('ll')}</td>
                  <td>{item.bank}</td>
                  <td>{item.paymentChannel}</td>
                </tr> 
              )}
            </tbody>
          </table>

          <TableHandler data={data} loading={loading} />

          {data?.length > itemsPerPage &&
            <div className="pagination-tab">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"} />
            </div>
					}
        </section>
      </main>
    </div>
  )
};

export default AllSubscriptions;